// extracted by mini-css-extract-plugin
export default {"wrapper":"Page_wrapper__c60Tz","header":"Page_header__raznc","goBack":"Page_goBack__Bq7qK","title":"Page_title__fwF9+","pageContent":"Page_pageContent__+rAmE"};